/* global navigator */
import React from 'react';
import { isEdge, isChrome, isFirefox, isSafari, isAndroid, isIos, isOpera } from 'react-device-detect';
import Ask from './Ask';
import Refuse from './Refuse';


function Alert({className, children, ...props}) {
    const classNames = ['alert'];
    if (className) {
        classNames.push(className);
    }
    return (
        <div className={classNames.join(' ')} {...props}>
            <i className="icon-warning alert__icon"></i>
            <div className="alert__text">
                {children}
            </div>
        </div>
    );
}


export default class GetUserMedia extends React.PureComponent {
        
    state = {
        showPopinInfo: false,
        showPopinRefuse: false,
        changeBrowser: false,
        authorized: false,
        waitAuthorization: false
    }
    
    
    async componentDidMount() {
        
        if (!isChrome && !isFirefox && !isSafari && !isEdge && !isOpera) {
            this.setState({
                changeBrowser: true
            });
            return;
        }
        
        this.state.showPopinInfo = await this.check();
        
        if (this.state.showPopinInfo) {
            this.forceUpdate();
        } else {
            try {
                this.getStream();
            } catch(err) {
                console.error('err', err);
            }
        }
    }
    
    async check() {
        return await window.sdk.videoconf().mediaDevices().needAccept();
    }
    
    ask2 = async () => {
        this.step2 = true;
        this.ask();
    }
    
    ask = async () => {
        await this.setState({
            showPopinInfo: false,
            showPopinRefuse: false
        });
        this.getStream();
    }
    
    async getStream() {
        let stream = await window.sdk.videoconf().mediaDevices().getUserMedia();
        if (stream.error) {
            this.setState({
                showPopinRefuse: true,
                waitAuthorization: true
            });
            if (stream.errorObject.name == 'AbortError' || stream.errorObject.name == 'NotReadableError')
                this.step2 = true;
            if (!this.step2) {
                this.interval = setInterval(async () => {
                    let c = await this.check();
                    if(!c) {
                        clearInterval(this.interval);
                        this.setState({
                            waitAuthorization: false
                        });
                    }
                }, 1000);
            } else {
                this.setState({
                    camUsed: true
                });
            }
        } else {
            this.setState({
                authorized: true
            });
            
            this.props.onStreamReady({
                stream
            });
        }
    }
    
    
    renderPopin() {
        if (this.state.changeBrowser) {
            return (
                <div className={'device-workflow'}>
                    <Alert className={'device-workflow__alert'}>
                        Votre navigateur n'est pas supporté, merci d'utiliser un navigateur tel chrome, firefox, edge ou safari
                    </Alert>
                </div>
            );
        }
        
        if (this.state.camUsed) {
            return (
                <div className={'device-workflow'}>
                    <Alert className={'device-workflow__alert'}>
                        Il semblerait que votre webcam soit utilisé par un autre logiciel (skype, teams, zooms ou un autre navigateur)<br />
                        Merci de vérifier et rafraichir votre navigateur
                    </Alert>
                    <div className={'device-workflow__actions'}>
                        <button className={'button button--primary'} onClick={el=>{ window.location.reload() }}>Rafraichir</button>
                    </div>
                </div>
            );
        }
        
        
        if (this.state.showPopinInfo) {
            return (
                <React.Fragment>
                    <div className={'device-workflow'}>
                        <Alert className={'device-workflow__alert'}>
                            Afin que les autres puissent vous voir et vous entendre, votre navigateur va demander l'accès à votre caméra et votre micro.
                        </Alert>
                        <div className={'device-workflow__text'}>
                            <Ask />
                        </div>
                        <div className={'device-workflow__actions'}>
                            <button className={'button button--primary'} onClick={ this.ask }>Demandez l'autorisation</button>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        
        if (this.state.showPopinRefuse) {
            return (
                <React.Fragment>
                    <div className={'device-workflow'}>
                        <Alert className={'device-workflow__alert'}>
                            Merci d'accepter l'accès à votre webcam
                        </Alert>
                        <Refuse />
                        <div className={'device-workflow__actions'}>
                            {(isSafari || isAndroid) &&
                                <button className={'button button--primary'} onClick={el=>{ window.location.reload() }}>Rééssayer</button>
                            }
                            { !isSafari && !isAndroid && this.state.waitAuthorization &&
                                <button className={'button button--primary'} onClick={ this.ask }>Vérifiez l'autorisation</button>
                            }
                            { !this.state.waitAuthorization &&
                                <button className={'button button--primary'} onClick={ this.ask2 }>Demandez l'autorisation</button>
                            }
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        
        return null;
    }
    
    render() {
        if (this.state.authorized) {
            return null;
        }
        
        return (
            <div className={'cam-box'}>
                 <div className={'cam-box-content'}>
                    { this.renderPopin() }
                 </div>
            </div>
        );
    }
        
}


